export const environment = {
  production: false,
  apiUrl: 'https://homolog.api.filainteligente.clinicasim.com/api',
  hubUrl: 'https://homolog.api.filainteligente.clinicasim.com/hub',
  apiVersion: '1',
  brandApiUrl: 'https://api.brandingmngr.clinicasim.com',
  version: '2.1.0',
  ambiente: 'Homologação',
  // Homolog lista as unidades da SiM e da Super no login, em qualquer domínio.
  empresasLogin: ['2', '16']
};
